<ng-container *transloco="let t">
    <ng-template #dayTime>
            <div class="title title__md">{{dateText}}</div>
            <div class="subtitle subtitle__md">{{t('competitor.table.day.time')}}</div>
    </ng-template>
    <ng-template #passTime>
        @if (passTimeText) {
            <div class="text-end">
               <div class="title title__md">{{passTimeText}}</div>
               <div class="subtitle subtitle__md">{{t("competitor.table.pass.time")}}</div>
            </div>
        }
    </ng-template>
    <ng-template #rank>
        @if (rankText) {
                <div class="badge-holder__badge badge-sm rank-badge">
                  <span class="text-uppercase">{{rankText}}</span>
                </div>
        }
    </ng-template>
    <ng-template #totalTime>
        @if (totalTimeText) {
            <div class="d-flex flex-column align-items-end">
                  <div class="title title__md">{{totalTimeText}}</div>
            <div class="subtitle subtitle__md">{{t('competitor.table.time.overall')}}</div>
             @if (totalTimeAfterPenalty && penalty) {
            <div class="tag orange small">({{penalty}}:00 {{t('competitor.table.penalty.label')}})</div>
            }
            </div>
        }
    </ng-template>

    <div class="w-100 shadow-border">
        <div class="timeline-content d-flex align-items-center justify-content-between flex-wrap"
             [class.cursor-pointer]="expandable"
             (click)="onExpand()">
            <div class="d-flex align-items-center gap-3">
                <div class="badge-holder__badge badge-sm" [ngClass]="badgeClass">
                    <span class="text-uppercase">{{badgeLabel}}</span>
                </div>
                <div class="desktop-only-detail">
                    <div>{{dateText}}</div>
                </div>
            </div>
            <div class="d-flex align-items-center gap-3">
                <div class="desktop-only-detail">
                    <ng-container *ngTemplateOutlet="passTime"></ng-container>
                </div>
                <div class="desktop-only-detail">
                    <ng-container *ngTemplateOutlet="totalTime"></ng-container>
                </div>
                <div class="desktop-only-detail">
                    <ng-container *ngTemplateOutlet="rank"></ng-container>
                </div>
                <div class="mobile-only-detail">
                    <ng-container *ngTemplateOutlet="totalTime"></ng-container>
                </div>

                @if (expandable) {
                <i class="bi color-grey-neutral-400" [ngClass]="expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                }
            </div>
        </div>

        @if (expandable && expanded) {
        @if (showTeamMembers) {
        <div class="member-panel">
            <div class="mobile-only-detail">
                <div class="d-flex align-items-center justify-content-between mb-1">
                    <div class="text-start">
                        <ng-container *ngTemplateOutlet="dayTime"></ng-container>
                    </div>
                    <div class="d-flex align-items-center justify-content-end gap-4">
                        <ng-container *ngTemplateOutlet="passTime"></ng-container>
                        <ng-container *ngTemplateOutlet="rank"></ng-container>
                    </div>
                </div>
                <div class="divider"></div>
            </div>

            @for (row of rows; track row.member.id; let last = $last) {
            <app-team-member-row
              [firstName]="row.member.firstName"
              [lastName]="row.member.lastName"
              [sex]="row.member.sex"
              [determines]="row.determines"
              [dayTimeText]="row.detail?.ps_tm | resultDateTime:row.detail?.ps_dc:race?.raceSettings?.measurementPrecisionType"
              [passTimeText]="row.detail?.nt_tm | resultTime:race?.raceSettings?.measurementPrecisionType"
              [totalTimeText]="(isFinish && row.member.competitorResultsDetail?.fn_pen)
                ? (row.member.competitorResultsDetail?.tl_tm_pen | resultTime:race?.raceSettings?.measurementPrecisionType)
                : (row.detail?.tl_tm | resultTime:race?.raceSettings?.measurementPrecisionType)"
              [showAfterPenaltyNote]="isFinish && !!row.member.competitorResultsDetail?.fn_pen"
              [penalty]="isFinish ? row.member.competitorResultsDetail?.fn_pen : null"
              [overallRank]="row.detail?.abrk"
              [sexRank]="row.detail?.sxrk"
              [categoryRank]="row.detail?.ctrk">
            </app-team-member-row>
            @if (!last) {
            <div class="mobile-only-detail">
                <div class="divider"></div>
            </div>
            }

            }
        </div>
        } @else {

        <div class="member-panel">
            <div class="d-flex justify-content-between">
                <div>
                    <div class="mobile-only-detail">
                        <ng-container *ngTemplateOutlet="dayTime"></ng-container>
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-4">
                    <div class="mobile-only-detail">
                        <ng-container *ngTemplateOutlet="passTime"></ng-container>
                    </div>
                    <div class="">
                        <app-ranking-panel
                                [cssClass]="'d-flex gap-4'"
                                [overallRank]="overallRank"
                                [sex]="competitorSex"
                                [sexRank]="sexRank"
                                [categoryRank]="categoryRank"
                        />
                    </div>
                </div>
            </div>

        </div>
        }
        }
    </div>
</ng-container>